import React from "react";
import UserSessionReducer from '@features/auth/reducers/user-session-reducer';
import { LocalStorage } from '@shared/services/main/storage';

const initialState = {
    user: LocalStorage.get('user'),
    error: null,
};

const UserSessionStore = ({children}) => {
    const [state, dispatch] = React.useReducer(UserSessionReducer, initialState);
    return (
        <UserSessionContext.Provider value={[state, dispatch]}>
            {children}
        </UserSessionContext.Provider>
    )
};

export const UserSessionContext = React.createContext(initialState);
export const useUserSessionContext = () => React.useContext(UserSessionContext); // the custom hook
export default UserSessionStore;